import { signal } from '@preact/signals';

import { isApiError } from '../api.js';

// Step-up (ONTWERP.md §11.1.1): gevoelige acties geven `403 step_up_required`; de webapp toont
// dan het wachtwoordvenster inline (StepUpDialog) en herhaalt de actie na bevestiging.

export interface StepUpRequest {
  resolve: () => void;
  reject: (reason: unknown) => void;
}

export const stepUpRequest = signal<StepUpRequest | null>(null);

export class StepUpCancelled extends Error {
  constructor() {
    super('step_up_cancelled');
    this.name = 'StepUpCancelled';
  }
}

/** Vraagt de gebruiker om het wachtwoord; lost op na een geslaagde POST /auth/step-up. */
export function requestStepUp(): Promise<void> {
  if (stepUpRequest.value) {
    // Al een venster open: wacht op dezelfde bevestiging.
    const current = stepUpRequest.value;
    return new Promise((resolve, reject) => {
      const prevResolve = current.resolve;
      const prevReject = current.reject;
      current.resolve = () => {
        prevResolve();
        resolve();
      };
      current.reject = (r) => {
        prevReject(r);
        reject(r);
      };
    });
  }
  return new Promise((resolve, reject) => {
    stepUpRequest.value = { resolve, reject };
  });
}

/** Voert `run` uit; bij 403 step_up_required eerst het wachtwoordvenster, dan één herhaling. */
export async function withStepUp<T>(run: () => Promise<T>): Promise<T> {
  try {
    return await run();
  } catch (e) {
    if (!isApiError(e, 403, 'step_up_required')) throw e;
    await requestStepUp();
    return run();
  }
}
